import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import {
  InstagramLogo,
  LinkedinLogo,
  EnvelopeSimple,
  Phone,
  MapPin,
} from "@phosphor-icons/react";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="main-footer"
      className="bg-[#0A1428] text-white pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16 pb-14 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block bg-white p-5 mb-5">
              <img
                src="https://customer-assets.emergentagent.com/job_makelaars360-hub/artifacts/5kh8xx10_1.png"
                alt="Makelaars360"
                className="h-20 w-auto"
              />
            </Link>
            <p className="text-white/60 max-w-md leading-relaxed">{t.footer.tagline}</p>

            <div className="flex gap-4 mt-8">
              <a
                href="https://www.instagram.com/makelaars360?igsh=aWQ0MWtiZ2FvMTV1"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram Makelaars360"
                data-testid="footer-instagram-link"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"
              >
                <InstagramLogo size={18} />
              </a>
              <a
                href="https://www.linkedin.com/in/michaela-capirone-238882261"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn Michaela Capirone"
                data-testid="footer-linkedin-link"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"
              >
                <LinkedinLogo size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#C5A059] mb-5 font-semibold">
              {t.footer.services}
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/#services" className="hover:text-[#C5A059] transition-colors">{t.services.items.wealth.title}</Link></li>
              <li><Link to="/#services" className="hover:text-[#C5A059] transition-colors">{t.services.items.sale.title}</Link></li>
              <li><Link to="/#services" className="hover:text-[#C5A059] transition-colors">{t.services.items.invest.title}</Link></li>
              <li><Link to="/#services" className="hover:text-[#C5A059] transition-colors">{t.services.items.auctions.title}</Link></li>
              <li><Link to="/#services" className="hover:text-[#C5A059] transition-colors">{t.services.items.interior.title}</Link></li>
              <li><Link to="/properties" className="hover:text-[#C5A059] transition-colors">{t.nav.properties}</Link></li>
              <li><Link to="/servizi-online" className="hover:text-[#C5A059] transition-colors">{t.nav.shop}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#C5A059] mb-5 font-semibold">
              {t.nav.contact}
            </h4>
            <ul className="space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 text-[#C5A059] flex-shrink-0" />
                <span>Piazza della Repubblica, 5<br />10034 Chivasso (TO), IT</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#C5A059] flex-shrink-0" />
                <a href="tel:+393935902294" className="hover:text-[#C5A059]">+39 393 590 2294</a>
              </li>
              <li className="flex items-center gap-3">
                <EnvelopeSimple size={16} className="text-[#C5A059] flex-shrink-0" />
                <a href="mailto:makelaars360@gmail.com" className="hover:text-[#C5A059]">makelaars360@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50">
          <p>© {year} Makelaars360. {t.footer.rights}</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#C5A059]">{t.footer.privacy}</a>
            <a href="#" className="hover:text-[#C5A059]">{t.footer.cookies}</a>
            <a href="#" className="hover:text-[#C5A059]">{t.footer.terms}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
